<style scoped>
  .negrito {font-weight: bold !important}
</style>
<template>
  <portal-box>
    <h1 class="title is-5" slot="titulo">
      Ranking dos produtos mais vendidos
    </h1>

    <template slot="menu">
      <b-tag class="is-small is-primary negrito">Últimos 6 meses</b-tag>
    </template>

    <b-table :data="lista" :loading="loading">
      <portal-lista-vazia slot="empty" />

      <template slot-scope="props">
        <b-table-column label="Pos">
          <small>{{ props.index + 1 }}º</small>
        </b-table-column>

        <b-table-column label="Código">
          {{ props.row.COD_ITEM }}
        </b-table-column>

        <b-table-column label="Nome">
          {{ props.row.B1_DESC }}
        </b-table-column>
      </template>
    </b-table>

  </portal-box>
</template>

<script>
  import {listagem} from '../mixins/listagem'

  export default {
    mixins: [listagem],
    created () {
      this.url = this.$URL.PRODUTO.RANKING
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/RankingProduto.vue